export const GET_AGENT_ENTITIES = 'GET_AGENT_ENTITIES';
export const CREATE_AGENT_ENTITY = 'CREATE_AGENT_ENTITY';
export const UPDATE_AGENT_ENTITY = 'UPDATE_AGENT_ENTITY';
export const DELETE_AGENT_ENTITY = 'DELETE_AGENT_ENTITY';
export const GET_AGENT_ENTITY_ITEMS = 'GET_AGENT_ENTITY_ITEMS';

export const SYSTEM_ENTITY = 2;
export const CUSTOM_ENTITY = 1;
